export const CONTACT_DETAILS = {
  whatsapp: '+27 67 622 8529',
  email: 'info@yabathoplatform.co.za',
  supportEmail: 'support@yabathoplatform.co.za',
  supportUrl: 'https://app.yabathoplatform.co.za/support',
  address:
    '194 Bancor Avenue, Menlyn Maine, Central Square, Shop No. 105A, Waterkloof Glen, Ext. 2, Pretoria East, 0181',
};

export const ABOUT_APP_TEXT = [
  'YaBatho Customer App is part of the YaBatho Platform, a delivery and ordering platform operated under The Chairman Group (Pty) Ltd.',
  'This customer application is used by customers to browse stores, place orders, make payments, and track deliveries.',
];

export const PRICING_DATA = {
  customer: [
    'Delivery fee is calculated at checkout based on the distance between the selected outlet and the customer delivery location.',
    'Orders above R250 within 1 km of the outlet qualify for free delivery.',
    'Orders up to 3 km are charged a flat delivery fee of R8.',
    'Orders beyond 3 km are charged R8 plus R3.50 per kilometre after 3 km.',
    'Delivery is available within a maximum 15 km radius from the outlet.',
    'A platform fee of 5% is charged on the order subtotal.',
    'VAT of 15% is included in the final total.',
    'Any tip added by the customer is included in the final total and passed through accordingly.',
  ],

  restaurant: [
    'Restaurants are onboarded onto the platform and receive orders placed by customers through YaBatho.',
    'Platform and service fees applicable to restaurants are governed by restaurant partnership terms and operational agreements.',
    'Restaurants do not receive customer delivery fees, platform fees, or VAT amounts as restaurant earnings.',
  ],

  rider: [
    'Rider earnings are calculated separately from customer pricing.',
    'Customer s shown at checkout are customer-facing charges and do not automatically equal rider earnings.',
    'Any customer tip linked to the delivery should be included in the rider payout flow according to platform rules.',
  ],
};

export const KYC_DATA = {
  customers: [
    'Full name',
    'Email address',
    'Mobile number',
    'Delivery address',
  ],

  restaurants: [
    'Business name',
    'Contact person full name, such as Owner or General Manager',
    'Email address',
    'Mobile number',
    'Business address',
    'Banking or payout information',
    'Supporting business information where required during onboarding',
  ],

  riders: [
    'Full name',
    'Email address',
    'Mobile number',
    'Identification details',
    'Vehicle and delivery-related information',
    'Banking or payout information',
  ],
};

export const EDD_INTRO =
  'We apply a risk-based due diligence process to individuals and businesses signing up on our platform, depending on the role of the user.';

export const EDD_POINTS = [
  'For general customer accounts, we collect and review basic onboarding information such as full name, email address, mobile number, and delivery-related information required for account use and order fulfilment.',
  'For merchants, restaurants, and delivery personnel, we apply additional checks beyond basic signup information.',
  'These checks may include review of contact information, business details, identity-related information where required, operational details relevant to the service being provided, and manual review before activation where necessary.',
  'Our due diligence process is designed to confirm legitimacy, reduce platform abuse and fraudulent activity, maintain trust and safety on the platform, and support responsible onboarding and payment operations.',
  'Where higher-risk situations are identified, we may carry out further review before allowing access to platform functionality or transactions.',
];

export const ACCEPTABLE_USE_INTRO = [
  'Our platform may only be used for lawful activities connected to the services made available through it.',
  'Users are expected to provide accurate information, use the platform responsibly, and comply with all applicable laws, regulations, and platform rules.',
];

export const ACCEPTABLE_USE_POINTS = [
  'Using the platform for fraudulent, deceptive, or unlawful purposes is prohibited.',
  'Providing false identity, business, payment, or account information is prohibited.',
  'Abusing payment processes, refunds, promotions, or order flows is prohibited.',
  'Listing, promoting, or facilitating prohibited goods or services is prohibited.',
  'Interfering with platform operations, security, or the experience of other users is prohibited.',
  'Engaging in harassment, threats, abuse, discrimination, or harmful conduct toward customers, merchants, riders, or staff is prohibited.',
  'Uploading or sharing misleading, harmful, or unlawful content is prohibited.',
  'Violating the rights of other users, third parties, or applicable regulatory requirements is prohibited.',
];

export const ACCEPTABLE_USE_OUTRO =
  'We reserve the right to investigate suspected misuse and to take appropriate action, including restricting, suspending, or terminating access to the platform where necessary.';

export const PAYMENT_FLOW_INTRO =
  'Our platform facilitates transactions between the customer, the service provider, and the platform, with iKhokha acting as the payment processor.';

export const PAYMENT_FLOW_STEPS = [
  'A customer places an order on the platform and proceeds to checkout.',
  'The total amount payable is calculated, including the order subtotal, applicable delivery charges, and platform fees where relevant.',
  'The customer makes payment through iKhokha using the available payment method.',
  'iKhokha securely processes the transaction on our behalf.',
  'Once payment is successful, the order is confirmed and sent to the relevant service provider for fulfilment.',
  'Funds are settled to our business account in line with iKhokha’s settlement process.',
  'After settlement, we allocate the relevant portions operationally based on the order structure, including merchant earnings, rider earnings, and platform charges.',
];

export const PAYMENT_FLOW_OUTRO =
  'In summary, the customer pays through iKhokha, iKhokha processes the payment securely, the platform receives settlement, and the relevant service providers are paid according to the completed transaction structure. Riders are also paid accordingly.';

export const DISPUTE_INTRO =
  'Customer disputes are managed through an internal review and resolution process designed to ensure fairness, accountability, and proper record-keeping.';

export const DISPUTE_STEPS = [
  'Receiving and recording the complaint.',
  'Reviewing the transaction and related records.',
  'Requesting a photo where necessary, such as for wrong orders or product issues.',
  'Contacting the relevant parties where clarification is needed.',
  'Determining whether a refund, adjustment, or other resolution is appropriate.',
  'Communicating the outcome to the customer.',
];

export const DISPUTE_OUTRO =
  'Where a matter cannot be resolved internally, or where payment-related escalation is required, the issue may be escalated through the appropriate iKhokha support or dispute channels.';

export const TERMS_USE_INTRO = [
  'Our platform may only be used for lawful activities connected to the services made available through it.',
  'Users are expected to provide accurate information, use the platform responsibly, and comply with all applicable laws, regulations, and platform rules.',
];

export const TERMS_USE_POINTS = [
  'Welcome to YaBatho Food Delivery. By using our app or services, you agree to comply with these Terms & Conditions. If you do not agree, please do not use our services.',

  'Account Registration',
  'To use our services, users must be at least 18 years old. You must create an account. You agree to provide accurate and complete information during registration and to keep your account information up to date. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. All orders are subject to availability of the restaurant and menu items.',

  'Ordering and Payment',
  'When you place an order through our app, you agree to provide accurate information about the items you wish to purchase and your delivery address. You are responsible for ensuring that your payment information is accurate and up to date. All payments are processed securely through our payment gateway, and you agree to pay all applicable fees and charges associated with your orders. Prices displayed in the app include delivery and platform fees where applicable. We reserve the right to cancel orders that are suspected to be fraudulent or in violation of our policies. Payment must be completed through the app or approved payment methods. Payment confirmation is required before order processing.',

  'Delivery and Service',
  'We strive to provide timely and accurate delivery of your orders. However, delivery times may vary based on factors such as restaurant preparation time, traffic conditions, and weather. We are not liable for any delays or issues that may arise during the delivery process. You are responsible for providing accurate delivery information and being available to receive your order at the specified address.',

  'Prohibited Conduct',
  'You agree not to use our services for any unlawful or prohibited activities, including but not limited to fraudulent transactions, harassment, abuse, or any conduct that violates our Acceptable Use Policy. We reserve the right to suspend or terminate your account if you engage in prohibited conduct.',

  'Intellectual Property',
  'All content and materials available on our app, including but not limited to text, graphics, logos, images, and software, are the property of YaBatho Food Delivery or its licensors and are protected by intellectual property laws. You may not use, reproduce, distribute, or create derivative works based on our content without our express written permission.',

  'Limitation of Liability',
  'To the fullest extent permitted by law, YaBatho Food Delivery shall not be liable for any direct, indirect, incidental, special, consequential, or punitive damages arising out of or in connection with your use of our services. This includes but is not limited to damages for loss of profits, goodwill, use, data, or other intangible losses.',

  'Changes to Terms & Conditions',
  'We reserve the right to modify these Terms & Conditions at any time. Any changes will be effective immediately upon posting on our app. Your continued use of our services after any modifications constitutes your acceptance of the updated Terms & Conditions.',
];

export const PRIVACY_POLICY_TEXT = `Privacy Policy
Last Updated: January 29, 2026

This application ("YaBatho App") respects and protects the privacy of all users.

Data Collection
We only collect information required to process orders, deliver food, and provide app functionality.

Data Usage
The collected information is used solely for:
- Fulfilling customer orders.
- Processing payments securely.
- Improving app performance.

Data Sharing
We do not sell personal data. We only share information where required by law or where needed to complete an order, such as with restaurants, delivery riders, payment processors, and support providers.

Voice Ordering
Voice ordering is a coming soon feature and is not currently active in the customer app. The current customer app does not collect microphone recordings or audio data for voice ordering.

Security
We use secure methods to protect your information from unauthorized access.

Contact Us
If you have questions about this Privacy Policy, contact us at:
support@yabathoplatform.co.za`;

export const FAQ_DATA = [
  {
    question: 'How do I track my order?',
    answer: 'Go to the Orders tab and open your active order.',
  },
  {
    question: 'Can I cancel an order?',
    answer:
      'Cancellation depends on the order status and the restaurant handling stage.',
  },
  {
    question: 'How do I contact support?',
    answer: 'Use Help & Support or email support@yabathoplatform.co.za.',
  },
  {
    question: 'How is delivery fee calculated?',
    answer:
      'Delivery fee is calculated at checkout based on the distance between the selected outlet and the customer delivery location.',
  },
  {
    question: 'Are tips included?',
    answer:
      'Yes. Any tip added by the customer is included in the final total and passed through according to platform rules.',
  },
];
